import {
  USER_LOGIN_STARTED,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
} from './UserActions'

// INITIAL STATE //
const initialState = {
  accessToken: undefined,
  error: undefined,
  refreshToken: undefined,
  isUserLoggedIn: undefined,
  user: undefined,
  timeOfLogin: undefined,
  userEmail: undefined,
  providerId: undefined
}

// REDUCERS //

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_STARTED:
      return {
        ...state,
        loading: true,
      }
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.data.data.attributes.access_token,
        refreshToken: action.payload.data.data.attributes.refresh_token,
        loading: false,
        isUserLoggedIn: true,
        error: null, 
        timeOfLogin: action.payload.date,
        providerId: action.payload.data.data.attributes.provider_id,
        userEmail: action.payload.data.data.attributes.email
      }
    case USER_LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isUserLoggedIn: false,
      }
    case USER_LOGOUT:
      return {
        ...state,
        isUserLoggedIn: false,
        user: undefined,
        accessToken: undefined,
      }
    default:
      return state
  }
}
